import React, {Component} from "react";
import {ButtonToolbar, Checkbox, Col, ControlLabel, Form, FormControl, FormGroup, Row} from "react-bootstrap";
import WyborKlientForm from "../../klienci/externalComponents/WyborKlientForm";
import {TopSelect} from "../../../../componentsTopsa/selects/TopSelects";
import TopDostepnosc from "../../../../componentsTopsa/dostepnosc/TopDostepnosc";
import ClientService from "../../../konfiguracja/biletyConfig/biletyApi/ClientService";
import initialData from "../../../../utilities/initialData/initialData";
import {TopButtonCancel, TopButtonSave} from "../../../../componentsTopsa/buttons/TopButtons";
import ValidatorMessages from "../../../../shared/validatorMessages/ValidatorMessages";
import LSService from "../../../../utilities/localStorageService/LSService";
import acc from 'accounting'
import ZnizkiService from "../../../konfiguracja/biletyConfig/znizki/ZnizkiService";
import {TopAlertInformacja} from "../../../../componentsTopsa/alerty/TopAlerts";
import moment from "moment";

export default class KartyForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            klient: null,
            trasa: null,
            miejscowosciNaTrasie: [],
            miejscowoscOd: null,
            miejscowoscDo: null,
            kierunek: null,
            status: null,
            okres: null,
            statusy: [
                {value: 'NOWA', label: 'nowa'},
                {value: 'PRZYJETA', label: 'przyjeta'},
                {value: 'GOTOWA', label: 'gotowa'},
                {value: 'ZWROCONA', label: 'zwrócona'}
                ],
            znizki: [],
            znizka: null,
            nrKarty: '',
            messages: [],
            klienci: [],
            cenazabilet: null,
            czyTylkoEKarta: false,
        };
        this.onChangeKlient = this.onChangeKlient.bind(this)
        this.onChangeTrasa = this.onChangeTrasa.bind(this)
        this.onChangeMiejscowoscOd = this.onChangeMiejscowoscOd.bind(this)
        this.onChangeMiejscowoscDo = this.onChangeMiejscowoscDo.bind(this)
        this.onChangeKierunek = this.onChangeKierunek.bind(this)
        this.onChangeOkres = this.onChangeOkres.bind(this)
        this.onChangeStatus = this.onChangeStatus.bind(this)
        this.onChangeZnizka = this.onChangeZnizka.bind(this)
        this.onChangeNrKarty = this.onChangeNrKarty.bind(this)
        this.onClickZapisz = this.onClickZapisz.bind(this)
        this.ustawEdycje = this.ustawEdycje.bind(this)
        this.znajdzCeneDlaBiletuMiesiecznego = this.znajdzCeneDlaBiletuMiesiecznego.bind(this)
    }

    componentDidMount() {

        if (Boolean(this.props.edytowana)) {
            this.ustawEdycje(this.props.edytowana)
        }
        else {
            this.setState({
                okres: initialData.returnOkresyMiesieczne()[2],
                kierunek: initialData.returnKierunkiMiesieczne()[0],
                status: this.state.statusy[2]
            })

            setTimeout(function () {
                if(Boolean(document.getElementById('inputNrKarty')))
                    document.getElementById('inputNrKarty').value = 'M'
            }, 500)
            this.setState({nrKarty: 'M'})

        }

        if (Boolean(LSService.pobierzKarteDoEdycji())) {
            this.setState({
                edytowana: LSService.pobierzKarteDoEdycji(),
                pokazFormularz: true
            })
            LSService.usunKarteDoEdycji()
        }

        if (Boolean(this.props.klientDoDodawania)) {
            this.setState({klient: this.props.klientDoDodawania})
        }

    }

    componentWillReceiveProps(nextprops) {
        if (Boolean(nextprops.edytowana)) {
            this.ustawEdycje(nextprops.edytowana)
        }

        if (Boolean(nextprops.klientDoDodawania)) {
            this.setState({klient: nextprops.klientDoDodawania})
        }

    }

    ustawEdycje(karta) {

        if (!Boolean(karta.czyTylkoEKarta) && !Boolean(karta.nrKarty)) {
            setTimeout(function () {
                if(Boolean(document.getElementById('inputNrKarty')))
                document.getElementById('inputNrKarty').value = 'M'
            }, 500)
            this.setState({nrKarty: 'M'})
        }
        if (!Boolean(karta.czyTylkoEKarta)) {
            if (Boolean(karta.nrKarty)) {
                if (Boolean(document.getElementById('inputNrKarty'))) {
                    document.getElementById('inputNrKarty').value = karta.nrKarty
                }
            }
        }


        this.setState({
            klient: this.state.klienci.find(k => k.idKl == karta.idKl),
            trasa: this.props.trasy.find(t => t.idTr == karta.idTr),
            kierunek: initialData.returnKierunkiMiesieczne().find(k => k.value == karta.kierunek),
            okres: initialData.returnOkresyMiesieczne().find(o => o.value == karta.okres),
            status: this.state.statusy.find(s => s.value == karta.status),
            nrKarty: karta.nrKarty,
            czyTylkoEKarta: Boolean(karta.tylkoEkarta)
        })

        ClientService.getMiejscowosciNaTrasie(karta.idTr).then(function (response) {
            if (Boolean(response.data)) {
                this.setState({
                    miejscowosciNaTrasie: response.data,
                    miejscowoscOd: response.data.find(m => m.idMi === karta.idMiOd),
                    miejscowoscDo: response.data.find(m => m.idMi === karta.idMiDo),
                })
                let obj = {
                    "data": moment().format('YYYY-MM-DD'),
                    "idMiDo": karta.idMiDo,
                    "idMiOd": karta.idMiOd,
                    "idTr": karta.idTr,
                    "kierunek": karta.kierunek,
                    "okres": karta.okres,
                    "uoperatora":true
                }

                ZnizkiService.getWszytskieZnizkiMiesieczne(obj).then(function (response) {
                    this.setState({znizki: response.data})
                    if (response.data.length > 0) {

                        if(response.data.find(z => z.rodz == karta.rodz)){
                            this.setState({
                                znizka: response.data.find(z => z.rodz == karta.rodz),
                                cenabiletu: response.data.find(z => z.rodz == karta.rodz).cena
                            })
                        }

                    }
                }.bind(this))
            }
        }.bind(this))
    }

    onChangeKlient(obj) {
        this.setState({klient: obj})
    }

    onChangeNrKarty(e) {
        if (e.target.value.length > 11) {
            document.getElementById('inputNrKarty').value = this.state.nrKarty
        } else {
            this.setState({nrKarty: e.target.value})
        }
    }

    onChangeTrasa(e) {
        this.setState({trasa: e})
        if (e !== null) {
            this.pobierzMiejscowosciNaTrasie(e)
        }

        this.znajdzCeneDlaBiletuMiesiecznego(this.state.miejscowoscOd, this.state.miejscowoscDo, e, this.state.kierunek, this.state.okres, this.state.znizka)
    }

    onChangeMiejscowoscOd(e) {
        this.setState({miejscowoscOd: e})
        this.pobierzZnizkiMiesieczne(this.state.trasa, e, this.state.miejscowoscDo)
        this.znajdzCeneDlaBiletuMiesiecznego(e, this.state.miejscowoscDo, this.state.trasa, this.state.kierunek, this.state.okres, this.state.znizka)

    }

    onChangeMiejscowoscDo(e) {
        this.setState({miejscowoscDo: e})
        this.pobierzZnizkiMiesieczne(this.state.trasa, this.state.miejscowoscOd, e)
        this.znajdzCeneDlaBiletuMiesiecznego(this.state.miejscowoscOd, e, this.state.trasa, this.state.kierunek, this.state.okres, this.state.znizka)
    }

    onChangeKierunek(e) {
        this.setState({kierunek: e})
        this.pobierzZnizkiMiesieczne(this.state.trasa, this.state.miejscowoscOd, this.state.miejscowoscDo, e)
        this.znajdzCeneDlaBiletuMiesiecznego(this.state.miejscowoscOd, this.state.miejscowoscDo, this.state.trasa, e, this.state.okres, this.state.znizka)
    }

    onChangeOkres(e) {
        this.setState({okres: e})
        this.pobierzZnizkiMiesieczne(this.state.trasa, this.state.miejscowoscOd, this.state.miejscowoscDo, this.state.kierunek, e)
        this.znajdzCeneDlaBiletuMiesiecznego(this.state.miejscowoscOd, this.state.miejscowoscDo, this.state.trasa, this.state.kierunek, e, this.state.znizka)
    }

    onChangeStatus(e) {
        this.setState({status: e})
    }

    onChangeZnizka(e) {
        this.setState({znizka: e})
        this.znajdzCeneDlaBiletuMiesiecznego(this.state.miejscowoscOd, this.state.miejscowoscDo, this.state.trasa, this.state.kierunek, this.state.okres, e)
    }

    pobierzMiejscowosciNaTrasie(trasa) {
        ClientService.getMiejscowosciNaTrasie(trasa.idTr).then(function (response) {
            if (Boolean(response.data)) {
                this.setState({
                    miejscowosciNaTrasie: response.data,
                    miejscowoscOd: response.data[0],
                    miejscowoscDo: response.data[response.data.length - 1],
                })
                this.pobierzZnizkiMiesieczne(this.state.trasa, response.data[0], response.data[response.data.length - 1])
            }
        }.bind(this))
    }

    pobierzZnizkiMiesieczne(trasa, mod, mdo, kierunek = this.state.kierunek, okres = this.state.okres) {
        let obj = {
            // "data": new Date().toJSON().substr(0, 9),
            "data": moment().format('YYYY-MM-DD'),
            "idMiDo": mdo.idMi,
            "idMiOd": mod.idMi,
            "idTr": trasa.idTr,
            "kierunek": kierunek.value,
            "okres": okres.value,
            "uoperatora":true
        }

        ZnizkiService.getWszytskieZnizkiMiesieczne(obj).then(function (response) {
            this.setState({znizki: response.data})
            if (response.data.length > 0) {
                let znizka = response.data[0]

                if(response.data.find(z => z.rodz === 'NM')){
                    znizka = response.data.find(z => z.rodz === 'NM')
                }

                this.setState({znizka: znizka, cenazabilet: znizka.cena})
            }
        }.bind(this))
    }

    renderTrasyOption(option) {
        return (
            <div>{option.nazTr}
                <TopDostepnosc wartoscWarunek={0} wartosc={option.status} czyMarginesLewy={true}/>
            </div>
        )
    }

    renderZnizka(option) {
        return (
            <div>
                <span className={'label label-ebus-default'} style={{color:'#fff', background:option.kolor}}>{option.rodz}</span> {option.nazZniz}
            </div>
        )
    }

    dodajDoValidatorMessages(message) {
        let arr = this.state.messages
        arr.push(message)
        this.setState({messages: arr})
    }

    onClickZapisz() {

        this.state.messages = []
        this.setState({messages: []})
        let poprawne = true

        if (!Boolean(this.state.trasa) || !Boolean(this.state.miejscowoscDo) || !Boolean(this.state.miejscowoscOd) || !Boolean(this.state.znizka) || !Boolean(this.state.status)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie uzupełniono w pełni formularza')
        } else {
            if (this.state.miejscowoscOd.kol > this.state.miejscowoscDo.kol) {
                poprawne = false
                this.dodajDoValidatorMessages('Niepoprawna kolejność miejscowości')
            }
        }

        if ((!this.state.czyTylkoEKarta)) {
            if (!Boolean(this.state.nrKarty)) {
                poprawne = false
                this.dodajDoValidatorMessages('Jeśli nie zaznaczono opcji "tylko eKarta", należy uzupełnić numer karty')
            } else {
                if (this.state.nrKarty[0] !== 'M') {
                    poprawne = false
                    this.dodajDoValidatorMessages('Numer karty musi się zaczynać od litery M')
                }
            }
        }

        if (poprawne) {

            if (this.props.czyEdycjaZWidokuDodawania) {
                let obj = this.props.edytowana;
                obj['idMiDo'] = this.state.miejscowoscDo.idMi;
                obj['idMiOd'] = this.state.miejscowoscOd.idMi;
                obj['idTr'] = this.state.trasa.idTr;
                obj['kierunek'] = this.state.kierunek.value;
                obj['okres'] = this.state.okres.value;
                obj['rodz'] = this.state.znizka.rodz;
                obj['status'] = this.state.status.value;
                obj['nrKarty'] = (this.state.czyTylkoEKarta) ? Boolean(this.props.edytowana) ? this.state.nrKarty : '' : this.state.nrKarty;
                obj['tylkoEkarta'] = this.state.czyTylkoEKarta;
                this.props.handleClickZapisz(obj, Boolean(this.props.edytowana))

            } else {
                let obj = {
                    "idKa": Boolean(this.props.edytowana) ? this.props.edytowana.idKa : '-1',
                    "idKl": Boolean(this.props.edytowana) ? this.props.edytowana.idKl : this.state.klient.idKl,
                    "idMiDo": this.state.miejscowoscDo.idMi,
                    "idMiOd": this.state.miejscowoscOd.idMi,
                    "idTr": this.state.trasa.idTr,
                    "kierunek": this.state.kierunek.value,
                    "okres": this.state.okres.value,
                    "rodz": this.state.znizka.rodz,
                    "status": this.state.status.value,
                    "nrKarty": (this.state.czyTylkoEKarta) ? Boolean(this.props.edytowana) ? this.state.nrKarty : '' : this.state.nrKarty,
                    "tylkoEkarta": this.state.czyTylkoEKarta
                }

                this.props.handleClickZapisz(obj, Boolean(this.props.edytowana))
            }

        }
    }

    znajdzCeneDlaBiletuMiesiecznego(mod, mdo, tr, kier, okr, zniz) {
        if (Boolean(mod) && Boolean(mod) && Boolean(tr) && Boolean(kier) && Boolean(okr) && Boolean(zniz)) {

            let data = new Date().toJSON().substr(0, 8)
            if (okr === "P2") {
                data = data + '16'
            } else data = data + '01'

            let obj = {
                data: data,
                idMiOd: mod.idMi,
                idMiDo: mdo.idMi,
                idTr: tr.idTr,
                kierunek: kier.value,
                okres: okr.value,
                "uoperatora":true
            }

            ZnizkiService.getWszytskieZnizkiMiesieczne(obj).then(function (response) {
                this.setState({
                    cenazabilet: Boolean(response.data.find(z => z.rodz === zniz.rodz)) ? response.data.find(z => z.rodz === zniz.rodz).cena : null
                })
            }.bind(this))
        }
    }

    render() {

        return (
            <div>
                {
                    (Boolean(this.props.edytowana)) || (Boolean(this.props.klientDoDodawania)) ?
                        '' :
                        <WyborKlientForm klienci={this.state.klienci} wstrzymajOdswiezanie={true} handleChangeKlient={this.onChangeKlient}
                                         czyEdycja={Boolean(this.props.edytowana)} edytowanyKlient={this.state.klient}/>
                }
                <div style={{marginTop: '15px'}}>
                    <fieldset>
                        <div className={'fieldset-label'}>{Boolean(this.props.edytowana) ? 'Edycja karty' : 'Nowa karta'}</div>
                        <Form horizontal={true}>
                            <FormGroup>
                                <Col xs={12}>
                                    {
                                        Boolean(this.props.edytowana) ?
                                            <h4>{'Klient:  ' + this.props.edytowana.imieKl + ' ' + this.props.edytowana.nazKl}</h4>
                                            :
                                            ''}
                                    {
                                        Boolean(this.props.klientDoDodawania) ?
                                            <h4>{'Klient:  ' + this.props.klientDoDodawania.imie + ' ' + this.props.klientDoDodawania.nazwisko}</h4>
                                            :
                                            ''}

                                </Col>
                                <Col xs={12} lg={3}>
                                    <ControlLabel>Trasa <span className={'req'}>*</span></ControlLabel>
                                    <TopSelect onChange={this.onChangeTrasa} value={this.state.trasa} options={this.props.trasy}
                                               valueKey={'idTr'} labelKey={'nazTr'}
                                               valueRenderer={this.renderTrasyOption} optionRenderer={this.renderTrasyOption} clearable={false}
                                    />
                                </Col>
                                <Col lg={2}>
                                    <ControlLabel>Miejscowość od <span className={'req'}>*</span></ControlLabel>
                                    <TopSelect onChange={this.onChangeMiejscowoscOd} value={this.state.miejscowoscOd}
                                               options={this.state.miejscowosciNaTrasie} disabled={!Boolean(this.state.trasa)}
                                               valueKey={'idMi'} labelKey={'nazMi'} clearable={false}
                                    />
                                </Col>
                                <Col lg={2}>
                                    <ControlLabel>Miejscowość do <span className={'req'}>*</span></ControlLabel>
                                    <TopSelect onChange={this.onChangeMiejscowoscDo} value={this.state.miejscowoscDo}
                                               options={this.state.miejscowosciNaTrasie} disabled={!Boolean(this.state.trasa)}
                                               valueKey={'idMi'} labelKey={'nazMi'} clearable={false}/>
                                </Col>
                                <Col lg={2}>
                                    <ControlLabel>Kierunek <span className={'req'}>*</span></ControlLabel>
                                    <TopSelect onChange={this.onChangeKierunek} value={this.state.kierunek}
                                               options={initialData.returnKierunkiMiesieczne()}
                                               clearable={false} disabled={!Boolean(this.state.trasa)}/>
                                </Col>
                                <Col lg={3}>
                                    <div className={'add-label-margin'}></div>
                                    {
                                        Boolean(this.state.cenazabilet) ?
                                            <span style={{fontWeight: 'bold'}}>Cena: {acc.formatMoney(this.state.cenazabilet)}
                                                {
                                                    this.state.znizka.rodz==='ZSPEC'?
                                                        <span style={{fontWeight: 'normal', fontSize:'12px'}}>
                                                        <TopAlertInformacja inline={true} text={'Cenę można ręcznie edytować podczas dodania biletu'}/>
                                                        </span>
                                                        :
                                                        ''
                                                }
                                            </span>
                                            :
                                            ''
                                    }
                                </Col>
                            </FormGroup>
                            <FormGroup>
                                <Col lg={2}>
                                    <ControlLabel>Okres <span className={'req'}>*</span></ControlLabel>
                                    <TopSelect onChange={this.onChangeOkres} value={this.state.okres} options={initialData.returnOkresyMiesieczne()}
                                               clearable={false} disabled={!Boolean(this.state.trasa)}/>
                                </Col>
                                <Col lg={3}>
                                    <ControlLabel>Zniżka <span className={'req'}>*</span></ControlLabel>
                                    <TopSelect onChange={this.onChangeZnizka} value={this.state.znizka} options={this.state.znizki}
                                               clearable={false} disabled={!Boolean(this.state.trasa)}
                                               valueKey={'idZn'} labelKey={'rodz'}
                                               valueRenderer={this.renderZnizka}
                                               optionRenderer={this.renderZnizka}/>
                                </Col>
                                <Col lg={2}>
                                    <ControlLabel>Status <span className={'req'}>*</span></ControlLabel>
                                    <TopSelect onChange={this.onChangeStatus} value={this.state.status} options={this.state.statusy}
                                               clearable={false} disabled={!Boolean(this.props.edytowana)}/>
                                </Col>
                                <Col lg={(!this.state.czyTylkoEKarta) ? 3 : 2}>
                                    <Row>
                                        <Col lg={(!this.state.czyTylkoEKarta) ? 5 : 12}>
                                            <div style={{marginTop: '25px'}}>
                                                <Checkbox checked={this.state.czyTylkoEKarta}
                                                          onClick={() => {
                                                              if (this.state.czyTylkoEKarta) {
                                                                  setTimeout(function () {
                                                                      document.getElementById('inputNrKarty').value = 'M'
                                                                  }, 500)
                                                                  this.setState({nrKarty: 'M'})
                                                              }
                                                              this.setState({czyTylkoEKarta: !this.state.czyTylkoEKarta})

                                                          }}>
                                                    Czy tylko eKarta?</Checkbox>
                                            </div>
                                        </Col>
                                        {
                                            (!this.state.czyTylkoEKarta) ?
                                                <Col lg={7}>
                                                    <ControlLabel>Nr karty <span className={'req'}>*</span></ControlLabel>
                                                    <FormControl onChange={this.onChangeNrKarty} id={'inputNrKarty'}/>
                                                </Col>
                                                :
                                                ''
                                        }
                                    </Row>
                                </Col>
                                <Col lg={2}>
                                    <div className={'add-label-margin'}></div>
                                    <ButtonToolbar>
                                        <TopButtonCancel onClick={() => {
                                            this.props.handleClickAnuluj()
                                        }}/>
                                        <TopButtonSave onClick={this.onClickZapisz}/>
                                    </ButtonToolbar>
                                </Col>
                            </FormGroup>
                            <FormGroup>
                                <ValidatorMessages messages={this.state.messages}/>
                            </FormGroup>
                        </Form>
                    </fieldset>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/klienciConfig/karty/components/KartyForm.js